// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.address.RentalManagerUserPropertyAddressWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, PropertyType, UserPropertyAddressUpdateResponseWebDto } from '../..';

interface UpdateParams {
  fullAddress: string;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  unitNumber?: string;
}

export const RentalManagerUserPropertyAddressWebApiHandler_update_Path = '/api/web/v1/users/properties/address/update';

/**
 * Update address for property
 */
export const RentalManagerUserPropertyAddressWebApiHandler_update = (getParams: UpdateParams, client = getClient()) => {
  return httpFrontEndRequest<UpdateParams, never, UserPropertyAddressUpdateResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyAddressWebApiHandler_update_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
